import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { NOTIFICATION_GROUP, NOTIFICATION_TYPE } from 'constant';

import { getNotifications, updateNotifications } from 'services/AccountService';

import useAuth from './useAuth';

const Context = createContext();

export const NotificationsProvider = ({ children }) => {
    const { user } = useAuth();
    const [notifications, setNotifications] = useState(null);
    const [isFromRegistration, setIsFromResgistration] = useState(false);
    const { search } = useLocation();

    useEffect(() => {
        if (isFromRegistration) {
            return;
        }
        const fromRegistration = new URLSearchParams(search).get('fromRegistration');
        setIsFromResgistration(fromRegistration);
    }, [search]);

    const accountMergeNotifications = useMemo(() => {
        if (!notifications) {
            return [];
        }
        return notifications.filter((n) => n.type === NOTIFICATION_TYPE['MERGED_ACCOUNT'] && !n.isRead);
    }, [notifications]);

    const fetchNotifications = useCallback(async (params) => {
        try {
            const notificationList = await getNotifications(params);
            setNotifications(notificationList);
        } catch (e) {}
    }, []);
    useEffect(() => {
        if (!user) {
            return;
        }
        fetchNotifications({
            group: NOTIFICATION_GROUP['ACCOUNT'],
            showRead: false,
        });
    }, [user, fetchNotifications]);

    const acknowledgeNotifications = (notificationType) => {
        updateNotifications(accountMergeNotifications.map(({ id }) => ({ id, isRead: true })));

        setNotifications((_notifications) =>
            _notifications.map((n) => {
                if (n.type !== notificationType) {
                    return n;
                }
                n.isRead = true;
                return n;
            })
        );
    };

    return (
        <Context.Provider
            value={{
                accountMergeNotifications,
                acknowledgeNotifications,
                isFromRegistration,
            }}
        >
            {children}
        </Context.Provider>
    );
};

const useNotifications = () => useContext(Context);

export default useNotifications;
